import { ModalProps, Modals } from "..";
import { Buttons } from "../../../atoms/Buttons";
import * as S from "./ModalWarn.style";

interface ModalWarnProps extends ModalProps {}

export const ModalWarn = ({ setModalShow }: ModalWarnProps) => {
  return (
    <Modals
      modalTitle="안내 및 주의사항"
      setModalShow={setModalShow}
      modalButtons={
        <Buttons
          type="button"
          size="md"
          layout="secondary"
          label="닫기"
          onClick={() => setModalShow(false)}
        />
      }
    >
      <S.ModalWarnTextBox>
        • &nbsp;하기 표는 트랜드 차트를 생성하기 위하여 센서를 선택하고, Y축
        옵션을 변경할 수 있는 기능을 제공합니다.
        <br />
        •&nbsp; 하기 표의 내용을 모두 선택한 후에 ‘차트 생성’ 버튼을 누르면
        상단에 트랜드 차트가 표시됩니다.
        <br />
        • &nbsp;차트 생성 후에 ‘Y축 옵션’을 변경하는 경우에는 다시 ‘차트 생성’
        버튼을 눌러야 변경 옵션이 반영된 차트가 재표시됩니다.
        <br />
        • &nbsp;안정적인 차트 생성을 위해서는 조회 기간은 24시간 이내, 센서는
        10개 이내까지 선택할 것을 권장합니다.
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;그 이상의 조건을 선택하는 경우에는 서버 사양, PC
        사양, 브라우져 특성에 의하여 차트가 정상적으로
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;표시되지 않을 수도 있습니다.
      </S.ModalWarnTextBox>
    </Modals>
  );
};
